export default __webpack_public_path__ + "static/media/con_body01.c6019c66.jpg";